//============================================================
// getIndexByPropertyValue
//============================================================
// Cycles through an array of objects and returns the index of the first array entry
// containing an object with a top level property matching the indicated value.
// 
// Comparison is case sensitive
//
// Returns null if item not found
Array.prototype.getIndexByPropertyValue = function(prop, val) {
    if (this.length == 0){ return null; }

    for (var i=0; i<this.length; i++){
        
        //skip if the property is not defined
        if (!this[i][prop]){ continue; }

        //Found it
        if (this[i][prop] === val){ return i; }
    }

    return null;
};

//============================================================
// sortObjectsBy
//============================================================
// Execute against an array of like objects
// Pass a list of arguments that correspond to first level properties on the objects to sort by
Array.prototype.sortObjectsBy = function(){
	
	//No thing to do
	if (this.length == 0){ return; }

	if (arguments.length == 0){  
		throw("[Array.sortObjectsBy] At least one sort property expected");
	}

	//Check the first item in the array to make sure it is an object (presuming the rest are)
	if (Object.prototype.toString.call(this[0]) !== "[object Object]"){
		throw("[Array.sortObjectsBy] Array does not appear to contain solely objects.");
	}

	var args = arguments; //close this so we have them inside the subfunction
	this.sort(function(objA, objB){
		
		for (var i=0; i<args.length; i++){
			var arg = args[i];

			//Keep sorting against the parameters until we have a direction
			if (objA[arg] < objB[arg]){ return -1; }
			else if (objA[arg] > objB[arg]){ return 1; }
		}
	});
};

//============================================================
// sortObjectsByDesc
//============================================================
// Execute against an array of like objects
// Pass a list of arguments that correspond to first level properties on the objects to sort by
Array.prototype.sortObjectsByDesc = function(){
	
	//No thing to do
	if (this.length == 0){ return; }

	if (arguments.length == 0){  
		throw("[Array.sortObjectsBy] At least one sort property expected");
	}

	//Check the first item in the array to make sure it is an object (presuming the rest are)
	if (Object.prototype.toString.call(this[0]) !== "[object Object]"){
		throw("[Array.sortObjectsBy] Array does not appear to contain solely objects.");
	}

	var args = arguments; //close this so we have them inside the subfunction
	this.sort(function(objA, objB){
		
		for (var i=0; i<args.length; i++){
			var arg = args[i];

			//Keep sorting against the parameters until we have a direction
			if (objA[arg] < objB[arg]){ return 1; }
			else if (objA[arg] > objB[arg]){ return -1; }
		}
	});
};

//============================================================
// sortObjectsByAdv
//============================================================
// Execute against an array of like objects
// Pass a list of sorting parameters as: 
//		( {prop:<string>, asc:<bool>}, {prop:<string>, asc:<bool>}, ... )
Array.prototype.sortObjectsByAdv = function(){
	
	//No thing to do
	if (this.length == 0){ return; }

	if (arguments.length == 0){  
		throw("[Array.sortObjectsBy] At least one sort parameter expected");
	}

	//Check the first item in the array to make sure it is an object (presuming the rest are)
	if (Object.prototype.toString.call(this[0]) !== "[object Object]"){
		throw("[Array.sortObjectsBy] Array does not appear to contain solely objects.");
	}

	var args = arguments; //close this so we have them inside the subfunction
	this.sort(function(objA, objB){
		
		for (var i=0; i<args.length; i++){
			var arg = args[i];

			//Keep sorting against the parameters until we have a direction
			if (objA[arg.prop] < objB[arg.prop]){ return arg.asc ? -1 : 1; }
			else if (objA[arg.prop] > objB[arg.prop]){ return arg.asc ? 1 : -1; }
		}
	});
};